import type { DeepPartial } from '@luna/utils-ts';

import type { ContactDataManagementFeatureConfig } from './type';

export const contactDataManagement: DeepPartial<ContactDataManagementFeatureConfig> = {
    phone: {
        summaryFormat: 'NATIONAL',
        typeValidation: false,
    },
};
